import { render } from "./CertificadoModal.vue?vue&type=template&id=0209e8c4"
import script from "./CertificadoModal.vue?vue&type=script&lang=js"
export * from "./CertificadoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__